exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wrapper.templates {\n  margin: 0;\n}\n.group.templates {\n  display: flex;\n  flex-direction: column;\n  margin: 0;\n}\n.group.templates > div {\n  margin: 0;\n}\n.group.templates .field {\n  white-space: nowrap;\n}\n.wrapper.elements {\n  margin: -1rem 0 -1rem -1rem;\n}\n.group.elements {\n  padding: 1rem 0 0 1rem;\n}\n.group.elements .list {\n  padding: 1rem 0 0 1rem;\n  margin: -1rem 0 0 -1rem;\n}\n.group.elements:empty {\n  padding-bottom: 2rem;\n  margin-top: -2rem;\n}\n.group.elements .ghost {\n  opacity: 0.5;\n}\n.group.elements .ghost:not(.list) {\n  margin-bottom: 1rem;\n}\n", ""]);

// exports
